function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.03 2C12.03 4.4 14 6.35 16.38 6.35H18.16V8.05C18.16 10.45 20.1 12.39 22.5 12.4V2.84C22.5 2.61722 22.4115 2.40356 22.254 2.24603C22.0964 2.0885 21.8828 2 21.66 2H12.03ZM7.27 6.8C7.27578 7.94926 7.73489 9.0498 8.54755 9.86246C9.3602 10.6751 10.4607 11.1342 11.61 11.14H13.41V12.86C13.4158 14.0093 13.8749 15.1098 14.6875 15.9225C15.5002 16.7351 16.6007 17.1942 17.75 17.2V7.63C17.7472 7.41076 17.6588 7.20129 17.5037 7.04625C17.3487 6.89121 17.1392 6.80285 16.92 6.8H7.27ZM2.5 11.6C2.5 14 4.45 15.94 6.85 15.94H8.63V17.66C8.64 20.05 10.58 22 12.97 22V12.43C12.97 12.2072 12.8815 11.9936 12.724 11.836C12.5664 11.6785 12.3528 11.59 12.13 11.59L2.5 11.6Z",
  fill: "white"
});

function SvgJiraWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraWhite);
export default __webpack_public_path__ + "static/media/jiraWhite.b7c55ea3.svg";
export { ForwardRef as ReactComponent };